import React from "react";
//import { EuiBadge } from "@elastic/eui";
//import "./styles.css";

export const EstadoParteCellRenderer = (params: any, cell:boolean) => {
  if (params.node.rowPinned) {
    return null;
  }

  const estado = params.value;

  //cellStyle:{ "text-align": "center", "line-height": "0px"}

  switch (estado) {
    case 1:
      return <span className="sinValidar">{"Sin Validar"}</span>
      case 2:
        return <span className="validadoArea">{"Área"}</span>
        case 3:
          return <span className="validadoFiscal">{"Fiscal"}</span>
          case 4:
            return <span className="validadoFacturacion">{"Facturación"}</span>
            case 5:
              return <span className="finSemana">{"Fin Semana"}</span>
    default:
      return <span className="badgeCell sinValidar">{"Sin Validar"}</span>
  }

  // switch (estado) {
  //   case 1:
  //     return cell ? <EuiBadge color="danger"  className="badgeCell">{"Sin Validar"}</EuiBadge> : "Sin Validar"
  //     case 2:
  //       return cell ? <EuiBadge color="primary" className="badgeCell">{"Área"}</EuiBadge> : "Área"
  //       case 3:
  //         return cell ? <EuiBadge color="secondary" className="badgeCell">{"Fiscal"}</EuiBadge> : "Fiscal"
  //         case 4:
  //           return cell ? <EuiBadge color="warning" className="badgeCell">{"Facturación"}</EuiBadge> : "Facturación"
  //           case 5:
  //             return cell ? <EuiBadge color="warning" className="badgeCell">{"Facturación"}</EuiBadge> : "Facturación"
  //   default:
  //     return cell ? <EuiBadge color="danger"  className="badgeCell">{"Sin Validar"}</EuiBadge> : "Sin Validar"
  // }
};